export default "__VITE_ASSET__4cd97d8a__"